import {Stack, Typography} from '@mui/material';
import {IconIllustration} from 'presentation/components';
import React, {Fragment} from 'react';
import {translations} from 'presentation/translations-new';
import {CustomDivider} from './styles';
import {AttachmentsProps} from './types';

const {attachment} = translations['pt-br'].privateFlow.refund.conferencePage;

export const Attachments = ({items}: AttachmentsProps) => (
	<Fragment>
		<Typography variant="subtitle2" fontWeight={600} color="primary">
			{attachment}
		</Typography>
		{items.map((item, index) => (
			<Stack key={item.title}>
				<Stack direction="row" alignItems="center" justifyContent="space-between">
					<Typography variant="body2">{item.title}</Typography>
					<IconIllustration
						size="smaller"
						customIconName="ben-export"
						variant="primary"
					/>
				</Stack>
				{items.length - 1 !== index ? <CustomDivider /> : null}
			</Stack>
		))}
	</Fragment>
);
